import { HEADER_STYLES } from '../HeaderConstants';

const UserProfile = ({ 
  userName, 
  userType, 
  isDropdownOpen, 
  dropdownRef, 
  toggleDropdown, 
  handleProfileManagement
}) => {
  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className={HEADER_STYLES.DROPDOWN_BUTTON}
      >
        <div className={HEADER_STYLES.USER_AVATAR}>
          <span className="text-white text-sm font-medium">
            {userName.charAt(0).toUpperCase()}
          </span>
        </div>
        <div className="flex flex-col items-start">
          <span className={HEADER_STYLES.USER_NAME}>
            {userName}
          </span>
          <span className={HEADER_STYLES.USER_TYPE}>
            {userType}
          </span>
        </div>
        <svg 
          className={`w-4 h-4 text-gray-500 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Dropdown Menu */}
      {isDropdownOpen && (
        <div className={HEADER_STYLES.DROPDOWN_MENU}>
          <button
            onClick={handleProfileManagement}
            className={HEADER_STYLES.DROPDOWN_ITEM}
          >
            Profile Management
          </button>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
